import React from 'react';
import { Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const MarkdownRenderer = ({ 
  content, 
  type = 'summary', // 'summary' | 'chapters'
  handleChapterClick,
  scrollToChapter,
  playerRef,
  isMobile 
}) => {
  // 기본 마크다운 렌더러 (요약용)
  const summaryComponents = {
    h1: ({ node, ...props }) => (
      <Typography {...props} variant="h5" sx={{ fontSize: 20, fontWeight: 700, color: '#1976d2', mt: 3, mb: 2 }} />
    ),
    h2: ({ node, ...props }) => (
      <Typography {...props} variant="h6" sx={{ fontSize: 18, fontWeight: 600, color: '#1976d2', mt: 2, mb: 1 }} />
    ),
    h3: ({ node, ...props }) => (
      <Typography {...props} variant="subtitle1" sx={{ fontSize: 16, fontWeight: 600, color: '#1976d2', mt: 2, mb: 1 }} />
    ),
    li: ({ node, ...props }) => (
      <Typography {...props} component="li" sx={{ fontSize: 15, color: '#444', lineHeight: 1.6, mb: 0.5 }} />
    ),
    p: ({ node, ...props }) => (
      <Typography {...props} sx={{ fontSize: 13, color: '#333', lineHeight: 1.7, mb: 1 }} />
    ),
    strong: ({ node, ...props }) => (
      <Typography {...props} component="span" sx={{ fontWeight: 700, color: '#1976d2' }} />
    ),
  };

  // 챕터용 마크다운 렌더러 (클릭 가능한 챕터 제목 포함)
  const chapterComponents = {
    p: ({ node, ...props }) => (
      <Typography {...props} sx={{ fontSize: 16, color: '#333', lineHeight: 1.7, mb: 1 }} />
    ),
    h2: ({ node, ...props }) => (
      <Typography {...props} variant="h5" sx={{ fontSize: 20, fontWeight: 600, color: '#1976d2', mt: 3, mb: 2 }} />
    ),
    h3: (props) => {
      // h3 요소의 텍스트에서 시간 정보 추출
      console.log('props.children:', props.children);
      console.log('props.children type:', typeof props.children);
      console.log('props.children isArray:', Array.isArray(props.children));
      
      let childText = '';
      if (typeof props.children === 'string') {
        childText = props.children;
      } else if (Array.isArray(props.children)) {
        childText = props.children.map(child => 
          typeof child === 'string' ? child : child?.toString?.() || ''
        ).join('');
      } else if (props.children?.toString) {
        childText = props.children.toString();
      }
      
      // 다양한 시간 형식 매칭 시도
      console.log('Original childText:', childText);
      let time = null;
      
      // 패턴 1: ([00:00]) 형태
      let timeMatch = childText.match(/\((\[\d{2}:\d{2}\])\)$/);
      if (timeMatch) {
        time = timeMatch[1];
      } else {
        // 패턴 2: [00:00] 형태 (괄호 없음)
        timeMatch = childText.match(/(\[\d{2}:\d{2}\])/);
        if (timeMatch) {
          time = timeMatch[1];
        } else {
          // 패턴 3: (00:00) 형태
          timeMatch = childText.match(/\((\d{2}:\d{2})\)$/);
          if (timeMatch) {
            time = `[${timeMatch[1]}]`;
          }
        }
      }
      
      console.log('Extracted time:', time);
      const idxMatch = childText.match(/^\s*(\d+)\./);
      const idx = idxMatch ? Number(idxMatch[1]) - 1 : null;
      
      return (
        <Typography
          {...props}
          variant="h6"
          id={idx !== null ? `chapter-${idx + 1}` : undefined}
          sx={{
            fontSize: 18,
            fontWeight: 600,
            color: '#1976d2',
            mt: 2,
            mb: 1,
            px: 1.2,
            py: 0.8,
            borderRadius: 1,
            backgroundColor: 'rgba(25, 118, 210, 0.08)',
            transition: 'background 0.2s',
            cursor: time ? 'pointer' : 'default',
            '&:hover': {
              backgroundColor: time ? 'rgba(25, 118, 210, 0.12)' : 'rgba(25, 118, 210, 0.08)'
            }
          }}
          onClick={(e) => {
            console.log('=== Chapter Title Clicked ===');
            console.log('Time:', time);
            console.log('PlayerRef exists:', !!playerRef?.current);
            console.log('Is Mobile:', isMobile);
            console.log('Event:', e);
            
            if (time && handleChapterClick) {
              handleChapterClick(time);
            } else {
              console.log('No time found in chapter title');
            }
          }}
        >
          {props.children}
        </Typography>
      );
    },
    li: ({ node, ...props }) => (
      <Typography {...props} component="li" sx={{ fontSize: 15, color: '#444', lineHeight: 1.6, mb: 0.5 }} />
    ),
    a: ({ node, ...props }) => (
      <Typography
        {...props}
        component="a"
        onClick={(e) => {
          e.preventDefault();
          // href가 #chapter-로 시작하면 스크롤 이동 (목차 클릭)
          if (props.href && props.href.startsWith('#chapter-')) {
            const chapterIndex = parseInt(props.href.replace('#chapter-', '')) - 1;
            if (scrollToChapter) {
              scrollToChapter(chapterIndex);
            }
          } else {
            // 시간 정보가 있으면 YouTube 플레이어 이동
            const time = props.href?.match(/\[(\d{2}:\d{2})\]/)?.[1];
            if (time && handleChapterClick) {
              handleChapterClick(`[${time}]`);
            }
          }
        }}
        sx={{
          color: '#1976d2',
          textDecoration: 'none',
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline'
          }
        }}
      />
    ),
  };

  const components = type === 'chapters' ? chapterComponents : summaryComponents;

  return (
    <ReactMarkdown
      children={content}
      components={components}
    />
  );
};

export default MarkdownRenderer; 